import React from 'react'
import { connect } from 'react-redux'
import './RiskProfiles.css'
import i18n from '../../i18n'
import { getSelectedApproach } from '../../reducers/data'
import './Approach.css'
import { setSelectedRiskProfiles } from '../../actions/data'


class RiskProfiles extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedButton: null,
      riskSelected: 'no',
    }
  }

  handleNumRiskProfile = (num) => {
    this.setState({
      selectedButton: num,
    })
  }

  handleRiskNextButton = () => {

    this.setState({
      riskSelected: 'yes',
    }, () => {

      this.props.setSelectedRiskProfiles(this.state.selectedButton);
    })
  }

  render() {

    const isAllocationSelected = this.state.selectedButton !== null

    return (
      <div className='risk'>

        <div className='risk-subtitle'>{i18n.t('num_risk_profiles')}</div>
        <div className='risk-buttons-container'>
          {[1, 2, 3, 4, 5].map(num => (
            <button
              className={`custom-model-risk-button ${num === this.state.selectedButton ? 'selected' : ''}`}
              key={num}
              onClick={() => this.handleNumRiskProfile(num)}
            >
              {num}
            </button>
          ))}
        </div>
        <div className='riskNextButtonContainer'>
          <button
            className={isAllocationSelected ? 'riskNextButton' : 'riskNextButtonDisabled'}
            onClick={() => {
              this.handleRiskNextButton();
            }}
            disabled={!isAllocationSelected}
          >
            Next
          </button>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  data: state.data,
  availableRiskProfiles: state.data.riskProfiles,
  selectedApproach: getSelectedApproach(state)
})

const mapDispatchToProps = dispatch => ({
  setSelectedRiskProfiles: selectedButtons =>
    dispatch(setSelectedRiskProfiles(selectedButtons)),

})

export default connect(mapStateToProps, mapDispatchToProps)(RiskProfiles)